import React from 'react';
import PropTypes from 'prop-types';
import './WindCompass.scss';

// Compass assets for dark theme
import compassRoseDark from '../../__assets/img/dashboard/dark/compassrose-1.svg';

// Compass assets for light theme
import compassRoseLight from '../../__assets/img/dashboard/light/compassrose-1.svg';

const WindCompass = ({
	direction = null,
	theme = 'dark',
	size = 160,
}) => {
	const compassRose = theme === 'light' ? compassRoseLight : compassRoseDark;

	// Arrow rotation - direction is where wind is coming FROM
	const arrowRotation = direction !== null ? direction : 0;

	return (
		<div
			className="wind-compass"
			style={{ width: size, height: size }}
		>
			<img
				src={compassRose}
				alt="Compass Rose"
				className="compass-rose"
			/>
			{direction !== null && (
				<svg
					className="compass-arrow"
					viewBox="0 0 100 100"
					style={{ transform: `rotate(${arrowRotation}deg)` }}
				>
					{/* Line from center to outer ring */}
					<line x1="50" y1="50" x2="50" y2="12" stroke="#00A835" strokeWidth="2" />
					{/* Arrowhead - extends to inner border of outermost circle */}
					<polygon points="50,8 46,16 54,16" fill="#00A835" />
				</svg>
			)}
		</div>
	);
};

WindCompass.propTypes = {
	direction: PropTypes.number,
	theme: PropTypes.oneOf(['dark', 'light']),
	size: PropTypes.number,
};

export default WindCompass;
